import React, { useRef } from 'react';
import '../../App.css';
import Cards from '../Cards';


import Navbar from '../Navbar';
import Model from '../Model';
import Ongoing from '../Ongoing';
import Service from './Service';
import Experience from './Experience';
import HomeSection from './HomeSection';
import Price from './Price';
import Footer from '../Footer';



function Home() {
  const homeSectionRef = useRef(null);
  const serviceRef = useRef(null);
  const priceRef = useRef(null);
  const ongoingRef = useRef(null);
  const completedRef = useRef(null);

  
  return (
    <>
    <Navbar
        homeSectionRef={homeSectionRef}
        serviceRef={serviceRef}
        priceRef={priceRef}
        ongoingRef={ongoingRef}
        completedRef={completedRef}
      />

    <div ref={homeSectionRef}>
        <HomeSection />
      </div>
      <Experience />
      <div ref={serviceRef}>
        <Service />
      </div>
      <div ref={ongoingRef}>
        <Ongoing />
      </div>
      <Model />
      <div ref={completedRef}>
        <Cards />
      </div>
      
      <div ref={priceRef}>
      <Price />
      </div>

      <Footer />
   
    </>
  );
}

export default Home;
